<template>
  <div>
    <div v-if="activeName === 'first'">
      <!-- 未结算 -->
      <div class="search">
        <div class="search_box">
          <div class="searchItem">
            <div class="label">业务员</div>
            <div class="field">
              {{ this.$store.getters.loginUser.username }}
            </div>
          </div>
          <div class="searchItem">
            <div class="label">收款日</div>
            <div class="field" style="width: 400px">
              <el-date-picker
                v-model="query.startTime"
                type="date"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              >
              </el-date-picker>
              <div style="margin: 0 10px">至</div>
              <el-date-picker
                v-model="query.endTime"
                type="date"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="searchItem">
            <div class="search_btn">
              <el-button type="primary" @click="search">查询</el-button>
            </div>
          </div>
          <div class="searchItem" style="margin:0 0 10px 10px;">
            <div class="search_btn">
              <el-button
                type="primary"
                @click="print"
                style="padding: 10px 20px"
                >打印结算申请</el-button
              >
            </div>
          </div>
          <div class="searchItem" style="margin:0 0 10px 10px;">
            <div class="search_btn">
              <excel
                :data="list"
                :fields="json_fields"
                :title="`${$store.state.user.loginUser.username}的业务绩效结算申请表`"
              />
            </div>
          </div>

          <!-- <div class="searchItem">
            <div class="field">
                <excel
                  :data="list"
                  :fields="cols"
                  :title="'【采购平台】业务员绩效结算申请表'"
                />
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <vggrid
      :random="Math.floor(Math.random() * 999999)"
      :list="list"
      tableheight="400"
      flexname=""
      :cols="cols"
      :showfooter="false"
      :showPage="false"
      :resizable="true"
      @cellClick="cellClick"
      @cellDblClick="viewProject"
    >
      <template slot="btn">
        <div style="display: flex; justify-content: space-between">
          <div>
            <span
              >共{{ query.count }}个项目，服务费合计{{
                amt.fwfprice | Thousands
              }}元</span
            >
          </div>
        </div>
      </template>
    </vggrid>
  </div>
</template>

<script>
import request from "@/utils/request";
import utils from "../../assets/js/utils";
import vggrid from "../../views/common/vggrid";
import dayjs from "dayjs";
import excel from "./excel.vue";
export default {
  name: "settlementTab",
  data() {
    return {
      cols: [
        {
          field: "projectcode",
          fieldtype: "I",
          title: "项目编号",
          calculExpr: "",
        },
        {
          field: "projectname",
          fieldtype: "I",
          title: "项目名称",
          calculExpr: "",
        },
        {
          field: "Pcomname",
          fieldtype: "I",
          title: "采购人",
          calculExpr: "",
        },
        {
          field: "projectlimitamtCN",
          fieldtype: "I",
          title: "预算额",
          calculExpr: "",
        },
        {
          field: "ptcusername",
          fieldtype: "I",
          title: "业务员",
          calculExpr: "",
        },
        {
          field: "confirmfeeamtCN",
          fieldtype: "I",
          title: "服务费（元）",
          calculExpr: "",
        },
        {
          field: "psufewreceivetime",
          fieldtype: "I",
          title: "收取日",
          calculExpr: "",
        },
      ],
      list: [],
      amt: {},
      query: {
        isMyself: 1,
        salerewardflg: 0,
        cosid: this.$store.getters.loginUser.cosid,
        userid: this.$store.getters.loginUser.userid,
        comid: this.$store.getters.loginUser.comid,
      },
      json_fields: [
        { title: "项目编号", field: "projectcode", width: 350 },
        { title: "项目名称", field: "projectname", width: 350 },
        { title: "采购人", field: "Pcomname", width: 350 },
        { title: "预算额（元）", field: "projectlimitamt", width: 350 },
        { title: "业务员", field: "ptcusername", width: 350 },
        { title: "服务费（元）", field: "confirmfeeamt", width: 350 },
        { title: "收取日", field: "psufewreceivetime", width: 350 },
        { title: "结算金额", field: "psusalerewardmoney", width: 350 },
        { title: "结算日", field: "psusalerewardtime", width: 350 },
        { title: "结算人", field: "psusalerewarder", width: 350 },
      ],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },
  components: { vggrid, excel },
  async activated() {
    await this.getPerformance();
  },
  async mounted() {
    await this.getPerformance();
  },
  props: {
    activeName: {},
  },
  watch: {
    async activeName() {
      this.list = [];
      if (this.activeName === "first") {
        await this.getPerformance();
      }
    },
  },
  filters: {
    Thousands(val) {
      return val ? utils.comdify(val) : 0;
    },
  },
  methods: {
    search() {
      // if (this.query.endTime) {
      this.query.endtTime_c = this.query.endTime
        ? dayjs(this.query.endTime).add(1, "day").format("YYYY-MM-D")
        : null;
      // }
      this.getPerformance();
    },
    async getPerformance() {
      this.query.isMyself = 1;
      this.query.salerewardflg = 0;

      let res = await request({
        url: "/basic/statisticalAnalysis/getPerformance",
        method: "get",
        params: this.query,
      });
      res.data.map((e) => {
        e.psufewreceivetime = utils.formatterDate(
          e.psufewreceivetime,
          "yyyy-MM-dd"
        );

        e.projectlimitamtCN = utils.comdify(e.projectlimitamt);
        e.confirmfeeamtCN = utils.comdify(e.confirmfeeamt);
        return e;
      })
      this.list = res.data
      this.query.count = res.count[0].count;
      this.amt = res.amt;
    },
    async cellClick(row) {
      this.model = row;
    },
    async viewProject(row) {
      this.model = row;
    },
    async print() {
      let { href } = this.$router.resolve({
        name: "settlemanetPrint",
        query: this.query,
      });
      window.open(href, "_blank");
    },
  },
};
</script>

<style scoped>
</style>
